"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "header-layout"
  }, [_c("div", {
    staticClass: "header-router"
  }, [_c("div", {
    staticClass: "logo",
    on: {
      click: function click($event) {
        return _vm.enterScreen();
      }
    }
  }, [_vm.logoImg ? _c("img", {
    staticClass: "logoImg",
    attrs: {
      src: _vm.logoImg,
      alt: ""
    }
  }) : _c("img", {
    staticClass: "logoImg",
    attrs: {
      src: require("../../assets/svg/logo.svg"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "tit"
  }, [_c("span", [_vm._v(_vm._s(_vm.projectInfo.entryName))]), _vm._v(" "), _vm.projectList !== undefined && _vm.projectList != null ? _c("Select") : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticClass: "bottom"
  }, [_c("div", {
    staticClass: "bottom-left"
  }, [_c("el-menu", {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      mode: "horizontal",
      "background-color": "#18213c",
      "text-color": "#fff",
      "active-text-color": "#85f2eb"
    },
    on: {
      select: _vm.handleSelect
    }
  }, [_vm.pathData.indexOf("home-page") !== -1 ? _c("el-menu-item", {
    attrs: {
      index: "0"
    },
    on: {
      click: function click($event) {
        return _vm.handleRoute("/home-page", 0);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("head.jsc")))]) : _vm._e(), _vm._v(" "), _vm.pathData.indexOf("system-details") !== -1 ? _c("el-menu-item", {
    attrs: {
      index: "1"
    },
    on: {
      click: function click($event) {
        return _vm.handleRoute("/system-details", 1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("head.yxjk")))]) : _vm._e(), _vm._v(" "), _vm.pathData.indexOf("data-query") !== -1 ? _c("el-menu-item", {
    attrs: {
      index: "3"
    },
    on: {
      click: function click($event) {
        return _vm.handleRoute("/data-query", 3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("head.sjfx")))]) : _vm._e(), _vm._v(" "), _vm.pathData.indexOf("report-download") !== -1 ? _c("el-menu-item", {
    attrs: {
      index: "4"
    },
    on: {
      click: function click($event) {
        return _vm.handleRoute("/report-download", 4);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("head.yxbb")))]) : _vm._e(), _vm._v(" "), _vm.pathData.indexOf("operation") !== -1 ? _c("el-menu-item", {
    attrs: {
      index: "6"
    },
    on: {
      click: function click($event) {
        return _vm.handleRoute("/operation", 6);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("head.ywgl")))]) : _vm._e(), _vm._v(" "), _vm.pathData.indexOf("maintain") !== -1 && _vm.userInfo.backStage === 0 ? _c("el-menu-item", {
    attrs: {
      index: "7"
    },
    on: {
      click: _vm.goToMananger
    }
  }, [_vm._v(_vm._s(_vm.$t("head.htgl")))]) : _vm._e()], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "bottom-right"
  }, [_c("div", {
    staticClass: "router-item"
  }, [_c("lang-select", {
    attrs: {
      width: "35px",
      height: "35px",
      color: "#85f2eb"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "router-item",
    on: {
      click: _vm.handleFullScreen
    }
  }, [_c("img", {
    staticClass: "img-box",
    attrs: {
      src: require("../../assets/svg/full.svg"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("head.qp")))])]), _vm._v(" "), _c("div", {
    staticClass: "router-item",
    on: {
      click: function click($event) {
        return _vm.handleRoute("/home", 0);
      }
    }
  }, [_c("img", {
    staticClass: "img-box",
    attrs: {
      src: require("../../assets/svg/return.svg"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("head.fh")))])])])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;